var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "story-maker-sticker-menu-music" }, [
    _c("audio", {
      ref: `music-preview`,
      on: { canplaythrough: (e) => (e.target.volume = "0.5") },
    }),
    _c("div", { staticClass: "header-menu" }, [
      _c("p", [_vm._v(_vm._s(_vm.$t("dash.post-creator.story.music-title")))]),
    ]),
    _c("div", { staticClass: "search-bar" }, [
      _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.models.search,
            expression: "models.search",
          },
        ],
        attrs: {
          placeholder: _vm.$t("dash.post-creator.overlay.search-music"),
        },
        domProps: { value: _vm.models.search },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.models, "search", $event.target.value)
          },
        },
      }),
    ]),
    !_vm.models.search
      ? _c(
          "div",
          { staticClass: "navigation" },
          _vm._l(Object.entries(_vm.feeds), function ([key, feed]) {
            return _c(
              "div",
              {
                staticClass: "item-nav",
                class: { active: _vm.selectedFeed === key },
                on: {
                  click: function ($event) {
                    return _vm.selectFeed(key)
                  },
                },
              },
              [_vm._v(_vm._s(feed.name))]
            )
          }),
          0
        )
      : _vm._e(),
    _c(
      "div",
      { staticClass: "list-item hide-scrollbar" },
      [
        _vm.stateLoader
          ? _c("span", { staticClass: "loader" })
          : _vm._l(
              _vm.models.search.length
                ? _vm.musics
                : _vm.dataInstagramDefault.musics[_vm.selectedFeed],
              function (music, index) {
                return _c(
                  "div",
                  {
                    key: `music${index}`,
                    staticClass: "item",
                    on: {
                      click: function ($event) {
                        return _vm.selectMusic(music)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: music.track
                          ? music.track.cover_artwork_thumbnail_uri
                          : music.original_sound.ig_artist.profile_pic_url,
                      },
                    }),
                    _c("div", { staticClass: "info" }, [
                      _c("h5", [
                        _vm._v(
                          _vm._s(
                            music.track
                              ? music.track.title
                              : music.original_sound.original_audio_title
                          )
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            `${
                              music.track
                                ? music.track.display_artist
                                : music.original_sound.ig_artist.full_name
                            } • ${Math.floor(
                              (music.track || music.original_sound)
                                .duration_in_ms / 60000
                            )}:${(
                              "0" +
                              Math.floor(
                                ((music.track || music.original_sound)
                                  .duration_in_ms %
                                  60000) /
                                  1000
                              )
                            ).slice(-2)}`
                          )
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "btn-control" }, [
                      _c("div", {
                        staticClass: "circle",
                        class: {
                          play:
                            _vm.urlMusicPlaying ==
                            (music.track || music.original_sound)
                              .progressive_download_url,
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleMusic(music)
                          },
                        },
                      }),
                    ]),
                  ]
                )
              }
            ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }